module.exports = __webpack_public_path__ + "static/media/facebook.e42ae029.svg";